import FilterCheckboxesContainer from './FilterCheckboxesContainer';

export default FilterCheckboxesContainer;
